<template>
    <span class="input-label-with-tooltip">
        {{ label }}

        <v-tooltip v-if="tooltip" max-width="250px" open-delay="300" top>
            <template v-slot:activator="{ on, attrs }">
                <v-icon class="input-label-tooltip-icon ml-1" color="primary" small v-bind="attrs" v-on="on">
                    mdi-information-outline
                </v-icon>
            </template>

            <span class="white--text" style="white-space: pre-line">{{ tooltip }}</span>
        </v-tooltip>
    </span>
</template>

<script>
export default {
    name: 'InputLabelWithTooltipComponent',
    props: {
        label: {
            type: String,
            required: true,
        },
        //Already translated text, no tooltip displayed when empty
        tooltip: {
            type: String,
            default: null,
        },
    },
}
</script>

<style scoped>
/* Vuetify disables pointer events on the field label while it is not floating, so it never steals a
   click meant for the input. That also swallows the hover the tooltip needs, restore it on the icon. */
.input-label-tooltip-icon {
    pointer-events: auto;
}
</style>
